
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost' | 'link';
  size?: 'sm' | 'base' | 'md' | 'lg';
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  ...props 
}) => {
  const baseStyles = "font-semibold rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-150 ease-in-out inline-flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed transform";

  let variantStyles = '';
  switch (variant) {
    case 'primary':
      variantStyles = 'bg-sky-600 text-white hover:bg-sky-700 focus:ring-sky-500 md:hover:-translate-y-px md:hover:shadow-md active:translate-y-0';
      break;
    case 'secondary':
      variantStyles = 'bg-slate-200 text-slate-700 hover:bg-slate-300 focus:ring-slate-400 md:hover:-translate-y-px md:hover:shadow-md active:translate-y-0';
      break;
    case 'danger':
      variantStyles = 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500 md:hover:-translate-y-px md:hover:shadow-md active:translate-y-0';
      break;
    case 'ghost':
      variantStyles = 'bg-transparent text-slate-700 hover:bg-slate-100 hover:text-sky-600 focus:ring-sky-500 shadow-none md:hover:-translate-y-px active:translate-y-0 active:bg-slate-100';
      break;
    case 'link':
      variantStyles = 'bg-transparent text-sky-600 hover:text-sky-800 hover:underline focus:ring-sky-500 shadow-none p-0';
      break;
  }

  let sizeStyles = '';
  switch (size) {
    case 'sm':
      sizeStyles = 'px-3 py-1.5 text-xs';
      break;
    case 'base':
      sizeStyles = 'px-3 py-2 text-sm';
      break;
    case 'md':
      sizeStyles = 'px-4 py-2 text-sm';
      break;
    case 'lg':
      sizeStyles = 'px-6 py-3 text-base';
      break;
  }

  return (
    <button
      className={`${baseStyles} ${variantStyles} ${sizeStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
    